let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ckLWK")).then(() => parcelRequire('inoGB'));